export enum UserCases {
    Pause="pause",
    Not_Available="not_available",
    Timer_Between="timer_between",
    Biding="biding",
}